<template>
  <div class="postDetail">
    <div class="ceil">
      <div class="head" v-if="info.user">
        <img :src="info.user.avatar" />
        <div class="info">
          <p class="nickname">{{ info.user.nickname }}</p>
          <p class="created_at">{{ info.created_at }}</p>
        </div>
      </div>
      <div class="body">
        <p class="title vmiddle">
          <span class="tag-top" v-if="info.is_top">置顶</span>
          <span class="tag-fine" v-if="info.is_fine">精</span>
          <span class="title-text">{{ info.title }}</span>
        </p>
        <div id="message" class="content" v-html="info.content"></div>
      </div>
      <div class="line"></div>
    </div>
    <!-- 列表 -->
    <Empty v-if="!commentList.length" :empty_type="{ name: '暂无评论' }" style="margin-top: 20vw;"></Empty>
    <List
      ref="list"
      :url="`/api/app/community/comment`"
      method="get"
      :params="params"
      :on-getdata="onGetdata"
      :showText="commentList.length > 0"
    >
      <ul slot="item" class="comment-list">
        <li
          v-for="item in commentList"
          :key="item.id"
          @click="replyUser(item.id, item.user.nickname)"
        >
          <img class="img" :src="item.user.avatar" />
          <div class="content">
            <div class="user">
              <p class="nick">{{ item.user.nickname }}</p>
              <p class="time">{{ item.created_at }}</p>
            </div>
            <p class="message">
              <template v-if="item.reply">
                回复
                <span class="name">@{{ item.reply.user.nickname }}</span>
              </template>
              <span class="msg" v-html="item.content"></span>
            </p>
          </div>
        </li>
      </ul>
    </List>
    <div class="evaluate">
      <img :src="user.avatar" v-show="overShow" />
      <!-- <div class="input"> -->
      <div v-show="!overShow" class="defultInput" @click="show()">{{ placeholder }}</div>
      <textarea :placeholder="placeholder" v-model="content" v-show="overShow" ref="inp" />
      <!-- </div> -->
      <div class="icon" v-show="!overShow">
        <span :class="info.is_liked ? 'supported' : 'support'" @click="zan()"></span>
        <span :class="info.is_collected ? 'collected' : 'collection'" @click="collect()"></span>
        <span class="share" @click="share()"></span>
      </div>
      <div class="send" v-show="overShow" @click="createComment()">发送</div>
    </div>
    <van-overlay :show="overShow" @click="overShow = false" />
    <book-share ref="share"></book-share>
    <!-- <back-spell :config="{redirect:'Index',title: '返回首页'}" v-if="$route.query.share_source"></back-spell> -->
  </div>
</template>
<script>
import List from "@/components/List";
import Empty from "@/components/Empty";
import bookShare from "@/components/book/BookShare.vue";

export default {
  name: "PostDetail",
  components: {
    List,
    Empty,
    bookShare
  },
  data() {
    return {
      title: {
        name: "帖子详情"
      },
      info: {},
      params: {
        post_id: this.$route.params.id
      },
      showShare: false,
      commentList: [],
      content: "",
      overShow: false,
      replyId: "",
      placeholder: "说说你的看法......",
      imgBox: [], // 图片
      current: 0 // 当前图片下标
    };
  },
  watch: {
    overShow() {
      if (!this.overShow) {
        this.placeholder = "说说你的看法....";
        this.replyId = "";
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.personInfo;
    }
  },
  methods: {
    onGetdata(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].content = data[i].content.replace(/\n/g, "<br/>");
        data[i].created_at = data[i].created_at.replace(/-/g, "/");
      }
      this.commentList = data;
    },
    // 获取帖子详情
    getDetail() {
      const that = this;
      that.$http
        .get("/api/app/community/post/" + this.$route.params.id, {
          group_id: that.$route.query.group_id
        })
        .then(res => {
          let count = 0;
          res.content = res.content.replace(
            /<img [^>]*src=['"]([^'"]+)[^>]*>/g,
            function(match, capture) {
              that.imgBox.push(capture);
              count++;
              return (
                match.substring(0, 4) +
                ' index="' +
                count +
                '"' +
                match.substring(4)
              );
            }
          );
          res.created_at = res.created_at.replace(/-/g, "/");
          that.info = res;
          this.$store.dispatch("setShare", {
            share_type: 2,
            route: this.$route,
            web_title: res.title,
            web_description: res.content_text,
            mobile_logo: this.$store.state.config.mobile_logo
          });
        });
    },
    //点赞
    zan() {
      const that = this;
      if (that.$pub.checkLogin(true, "push")) {
        that.$http
          .post("/api/app/community/post/like", {
            post_id: that.$route.params.id
          })
          .then(() => {
            that.$toast({
              message: that.info.is_liked == 0 ? "点赞成功！" : "取消点赞成功！"
            });
            if (that.info.is_liked) {
              that.info.like_num--;
              that.info.is_liked = 0;
            } else {
              that.info.like_num++;
              that.info.is_liked = 1;
            }
          });
      } else {
        that.$router.push({
          name: "SmsLogin"
        });
      }
    },
    //收藏
    async collect() {
      const that = this;
      if (that.$pub.checkLogin(true, "push")) {
        if (that.info.is_collected) {
          await that.$http.put(
            "/api/app/collect/cancel/" + that.info.collect_id + "/6"
          );
        } else {
          await that.$http.post("/api/app/collect", {
            post_id: that.$route.params.id,
            type: 6
          });
        }
        that.$toast({
          message:
            that.info.is_collected == 0 ? "收藏成功！" : "取消收藏成功！",
          duration: 800
        });
        if (that.info.is_collected) {
          that.info.is_collected = 0;
        } else {
          that.info.is_collected = 1;
        }
      } else {
        that.$router.push({
          name: "SmsLogin"
        });
      }
    },
    // 分享
    share() {
      if (this.$pub.checkLogin(true, "push")) {
        this.showShare = true;
        this.$nextTick(() => {
          this.$refs.share.showModel();
        });
      }
    },
    // 回复评论
    replyUser(id, name) {
      this.replyId = id;
      this.placeholder = "回复 @" + name;
    },
    // 打开输入框
    show() {
      const that = this;
      if (that.$pub.checkLogin(true, "push")) {
        that.overShow = true;
        that.$nextTick(() => {
          this.$refs.inp.focus();
        });
      } else {
        that.$router.push({
          name: "SmsLogin"
        });
      }
    },
    // 评论
    createComment() {
      const that = this;
      if (that.content == "") {
        return;
      }
      that.$http
        .post("/api/app/community/comment", {
          post_id: that.$route.params.id,
          reply_id: that.replyId,
          content: that.content
        })
        .then(() => {
          that.$toast("评论成功");
          that.$refs.list.reset();
          that.overShow = false;
          that.content = "";
        });
    }
  },
  created() {
    this.getDetail();
  },
  mounted: function() {
    const that = this;
    // 图片预览
    this.$nextTick(() => {
      $("#message").on("click", "img", ev => {
        that.current = parseInt(ev.currentTarget.attributes.index.value) - 1;
        that.$imgPreview({
          images: that.imgBox,
          startPosition: that.current
        });
      });
    });
  }
};
</script>
<style lang="scss" scoped>
.postDetail {
  padding-bottom: 100px;
  box-sizing: border-box;
  min-height: 100vw;
  .ceil {
    background-color: #fff;
    .head {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 130px;
      padding: 0 30px;
      border-bottom: 1px solid #f5f5f5;
      box-sizing: border-box;
      img {
        width: 76px;
        height: 76px;
        border-radius: 50%;
        flex-shrink: 0;
      }
      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 20px;
        box-sizing: border-box;
        flex: 1;
        .nickname {
          font-size: 28px;
          font-family: PingFangSC-Regular;
          color: #20242a;
        }
        .created_at {
          font-size: 26px;
          font-family: PingFangSC-Regular;
          color: #b7b7b7;
        }
      }
    }
    .body {
      padding: 20px 30px 30px;
      box-sizing: border-box;
      .title {
        margin: 24px 0 33px 0;
        .tag-top {
          background-color: #ff2e12;
          font-size: 20px;
          border-radius: 10px;
          color: #fff;
          padding: 2px 15px;
          margin-right: 10px;
        }
        .tag-fine {
          background-color: #fc9630;
          font-size: 20px;
          border-radius: 10px;
          color: #fff;
          padding: 2px 10px;
          margin-right: 18px;
        }
        .title-text {
          position: relative;
          font-size: 40px;
          color: #20242a;
          line-height: 66px;
          word-wrap: break-word;
        }
      }
      .content {
        width: 100%;
        // line-height: 50px;
        overflow: hidden;
        box-sizing: border-box;
        & /deep/ p {
          font-size: 32px;
          line-height: 50px;
        }
        & /deep/ img {
          display: block;
          max-width: 100%;
        }
      }
    }
    .line {
      width: 100%;
      height: 20px;
      background-color: #f0f2f5;
    }
  }
  .comment-list {
    margin-top: 20px;
    padding: 0 30px;
    background-color: #fff;
    li {
      position: relative;
      display: flex;
      justify-content: flex-start;
      padding: 40px 0 30px;
      overflow: hidden;
      border-bottom: 1px solid #e8e8e8;
      &:last-child {
        border-bottom: none;
      }
      img {
        display: block;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        flex-shrink: 0;
      }
      .content {
        margin-left: 20px;
        flex: 1;
        .user {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .nick {
            font-size: 24px;
            color: #595959;
          }
          .time {
            margin-left: 20px;
            font-size: 24px;
            color: rgba(0, 0, 0, 0.25);
          }
        }
        .message {
          margin-top: 20px;
          line-height: 40px;
          font-size: 26px;
          color: #595959;
          .name {
            color: #4169ff;
          }
          .msg {
            word-break: break-all;
          }
        }
      }
    }
  }
  .evaluate {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: 88px;
    padding: 0 30px;
    background-color: #fff;
    box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.04);
    z-index: 2000;
    img {
      width: 52px;
      height: 52px;
      border-radius: 50%;
    }
    .defultInput {
      width: 520px;
      height: 52px;
      margin: 0;
      padding: 0 40px;
      border: 0;
      border-radius: 26px;
      background: #f3f3f3;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      text-align: left;
      color: #999;
      line-height: 52px;
      box-sizing: border-box;
      overflow: hidden;
    }
    textarea {
      width: 520px;
      height: 52px;
      margin: 0 20px;
      padding: 10px 40px;
      border: 0;
      background: #f3f3f3;
      border-radius: 26px;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      line-height: 32px;
      outline: none;
      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .icon {
      display: flex;
      flex: 1;
      padding-left: 27px;
      box-sizing: border-box;
      height: 100%;
      justify-content: space-between;
      span {
        width: 42px;
        height: 42px;
        margin: auto 0;
      }
      .support {
        background: url("../../assets/images/community/icon_fourm_show_zan.png")
          center no-repeat;
        background-size: 28px 28px;
      }
      .supported {
        background: url("../../assets/theme-img/icon_fourm_zan_active.png")
          center no-repeat;
        background-size: 28px 28px;
      }
      .collection {
        background: url("../../assets/images/community/icon_fourm_show_collect.png")
          center no-repeat;
        background-size: 30px 28px;
      }
      .collected {
        background: url("../../assets/theme-img/icon_fourm_show_collect_active.png")
          center no-repeat;
        background-size: 30px 28px;
      }
      .share {
        background: url("../../assets/images/community/icon_fourm_show_share.png")
          center no-repeat;
        background-size: 28px 28px;
      }
    }
    .send {
      height: 52px;
      font-size: 28px;
      font-family: PingFangSC-Regular;
      color: rgba(51, 51, 51, 1);
      line-height: 52px;
    }
  }
}
</style>
